// extracted by mini-css-extract-plugin
module.exports = {"ColumnImageSection":"ColumnImageSection_ColumnImageSection__H_kf9","column":"ColumnImageSection_column__dQcWa","subheading":"ColumnImageSection_subheading__NrwJD"};